import React, {useEffect} from 'react'
import "./EducationCard.css";
import AOS from "aos";
import "aos/dist/aos.css";

const EducationCard = ({info}) => {

  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 200,
      easing: "ease-in-sine",
      delay: 50,
    });
  }, []);

  return (
    <div className="school-card" data-aos="fade-right">
            <h4>{info.school}</h4>
            <div className="school-duration">
                <p>{info.date}</p>
            </div>
            <ul>
                {info.expertise.map((item) =>
                    <li key={item}>{item}</li>)}
            </ul>
        </div>
  )
}

export default EducationCard